import { Inject, Injectable } from '@angular/core';
import { marker as i18n } from '@ngneat/transloco-keys-manager/marker';
import { map, Observable } from 'rxjs';
import { TranslateFunction } from '@bbraun/shared/util-transloco-ng';
import {
  ValidatorFactory,
  ValidatorFactoryFunction,
} from '@bbraun/bav-reporting/ui-report-editor';
import { createIsLowerOrEqualToPropertyValidator } from '../create-validators';
import { FeatureAisReportsScopedTranslationService } from '../../../services/feature-ais-reports-scoped-translation.service';

export const IS_LOWER_OR_EQUAL_TO_PROPERTY_ID = 'IS_LOWER_OR_EQUAL_TO_PROPERTY';
export const IS_LOWER_OR_EQUAL_TO_PROPERTY_ERROR = Symbol(
  IS_LOWER_OR_EQUAL_TO_PROPERTY_ID,
);

@Injectable({
  providedIn: 'root',
})
export class IsLowerOrEqualToPropertyValidatorFactory
  implements ValidatorFactory<{ property: string }>
{
  readonly id = IS_LOWER_OR_EQUAL_TO_PROPERTY_ID;
  readonly validatorFn: Observable<
    ValidatorFactoryFunction<{ property: string }>
  >;

  constructor(
    @Inject(FeatureAisReportsScopedTranslationService)
    private readonly scopedTranslationService: {
      loadedLang$: Observable<{ translate: TranslateFunction }>;
    },
  ) {
    this.validatorFn = this.scopedTranslationService.loadedLang$.pipe(
      map(({ translate }) => ({ property }) => ({
        id: IS_LOWER_OR_EQUAL_TO_PROPERTY_ERROR,
        validate: createIsLowerOrEqualToPropertyValidator(property),
        message: translate(
          i18n(
            'bbraunBavReportingFeatureAisReports.validation.isLowerOrEqualToProperty.error.message',
          ),
          { property },
        ),
      })),
    );
  }
}
